export default "__VITE_ASSET__si$uG$_7__"